import { type ComponentConfig, type SlotComponent } from '@puckeditor/core';
import styled from '@emotion/styled';
import { css_gap, css_rail, css_rail_up } from '~/emotion/theme';
import MicrositeSection from '~/components/MicrositeSection';
import { IsGridProvider } from '~/hooks/useIsGrid';

export interface GridBlockProps {
	main: SlotComponent;
	rail?: SlotComponent;
}

export const PUCK_BLOCK_GRID: ComponentConfig<GridBlockProps> = {
	label: 'Grid',
	fields: {
		main: {
			type: 'slot',
		},
		rail: {
			type: 'slot',
		},
	},
	render(props) {
		return <GridBlock {...props} />;
	},
};

const Grid = styled.div`
	@media (${css_rail_up}) {
		display: flex;
		min-height: 10rem;
		gap: ${css_gap('grid')};
	}
`;

const Main = styled.div`
	flex: 1;
`;

const Rail = styled.div`
	@media (${css_rail_up}) {
		width: ${css_rail};
	}
`;

export default function GridBlock(props: GridBlockProps) {
	return (
		<IsGridProvider>
			<MicrositeSection fill>
				<Grid>
					<Main>{props.main()}</Main>
					{props.rail && <Rail>{props.rail()}</Rail>}
				</Grid>
			</MicrositeSection>
		</IsGridProvider>
	);
}
